import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from 'vue'
import { useClipboard } from '@vueuse/core'


export default /*@__PURE__*/_defineComponent({
  __name: 'HoverToCopy',
  props: {
    textToCopy: {}
  },
  emits: ["on-copy"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { copy } = useClipboard({ legacy: true })

const slot = ref<HTMLElement | null>(null)
const text = computed(() => slot.value?.textContent?.trim())

const handleClipboard = async () => {
  const content = props.textToCopy ?? text.value

  if (!content) return

  await copy(content)
  emit('on-copy', content)
}

return (_ctx: any,_cache: any) => {
  const _component_sword_tooltip = _resolveComponent("sword-tooltip")!

  return (_openBlock(), _createBlock(_component_sword_tooltip, { placement: "top" }, {
    tooltip: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('COPY.CLIPBOARD')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", {
        ref_key: "slot",
        ref: slot,
        class: "cursor-pointer hover:bg-gray-200 hover:text-primary",
        onClick: handleClipboard
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 512)
    ], undefined, true),
    _: 3
  }))
}
}

})